module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-tokai-2-a546d3c3b3d9b4f11fc6f8d3e9ea7fc6.jpg";